module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"uk":{"close":"Закрити","read-more":"Читати далі","collapse":"Згорнути"},"en":{"close":"Close","read-more":"Read more","collapse":"Collapse"}}')
  delete Component.options._Ctor
}
